import React from 'react'

import { Button, Modal } from '_zari/core'

const ConfirmarProcesamientoModal = ({ handleClose, show, procesarRegistros }) => {
  return (
    <Modal show={show} onHide={handleClose}>
      <Modal.Header>
        <Modal.Title>CONFIRMAR PROCESAMIENTO</Modal.Title>
      </Modal.Header>
      <Modal.Body className='text-center'>
        <h4>La fecha ingresada no coincide con la del mes actual.</h4>
        <h3>¿Desea continuar?</h3>
      </Modal.Body>
      <Modal.Footer>
        <Button color='secondary' onClick={handleClose}>
          Cancelar
        </Button>
        <Button type='submit' onClick={procesarRegistros}>
          Confirmar
        </Button>
      </Modal.Footer>
    </Modal>
  )
}

export default ConfirmarProcesamientoModal
